import React from 'react';
import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';

const CustomDomainPayWall = props => {
  console.log('OOPS, you gotta pay');

  return (
    <Box layerStyle="tabPanel">
      <Box borderBottom="1px solid" borderBottomColor="greyScale.200" p={8}>
        Hey, you gotta pay!
      </Box>
    </Box>
  );
};

CustomDomainPayWall.propTypes = {};

export default CustomDomainPayWall;
